import {
  EditDoctorTeamTypeListActionTypes,
  EDIT_DOCTOR_TEAM_TYPE_FAIL,
  EDIT_DOCTOR_TEAM_TYPE_LOADING,
  EDIT_DOCTOR_TEAM_TYPE_SUCCESS,
  EditDoctorTeamTypeListState,
  EDIT_DOCTOR_TEAM_TYPE_UPDATE_API_MSG,
  EDIT_DOCTOR_TEAM_TYPE_UPDATE_API_RES,
} from "./ActionTypes";
import { EditDoctorTeamTypeListRes } from "./Model";

const initialStateEditPosts: EditDoctorTeamTypeListState = {
  loading: false,
  editDoctorTeamTypeRes: {} as EditDoctorTeamTypeListRes,
  successMsg: "",
  errorMsg: "",
  status: 0,
};
export const editDoctorTeamTypeReducer = (
  state = initialStateEditPosts,
  action: EditDoctorTeamTypeListActionTypes
): EditDoctorTeamTypeListState => {
  switch (action.type) {
    case EDIT_DOCTOR_TEAM_TYPE_LOADING:
      return {
        ...state,
        loading: action.loading,
      };
    case EDIT_DOCTOR_TEAM_TYPE_SUCCESS:
      return {
        ...state,
        editDoctorTeamTypeRes: action.payload,
        successMsg: action.successMsg,
      };
    case EDIT_DOCTOR_TEAM_TYPE_FAIL:
      return {
        ...state,
        editDoctorTeamTypeRes: action.payload,
        errorMsg: action.errorMsg,
        status: action.status,
      };
    case EDIT_DOCTOR_TEAM_TYPE_UPDATE_API_MSG:
      return {
        ...state,
        editDoctorTeamTypeRes: action.payload,
        successMsg: action.successMsg,
        errorMsg: action.errorMsg,
        status: action.status,
      };
    case EDIT_DOCTOR_TEAM_TYPE_UPDATE_API_RES:
      return {
        ...state,
        editDoctorTeamTypeRes: action.payload,
        successMsg: action.successMsg,
        errorMsg: action.errorMsg,
        status: action.status,
      };
    default:
      return state;
  }
};
